import { useGetAll } from "./crudService";

const endpoint:string = 'stats';

export function useGetAllStats() {
    return useGetAll({queryKey: [endpoint]});
}
